var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00015 10.1698L2.53015 6.69983C2.34317 6.51286 2.08957 6.40781 1.82515 6.40781C1.56072 6.40781 1.30712 6.51286 1.12015 6.69983C0.933168 6.88681 0.828125 7.14041 0.828125 7.40483C0.828125 7.53576 0.853914 7.66541 0.904019 7.78638C0.954124 7.90734 1.02756 8.01725 1.12015 8.10983L5.30015 12.2898C5.69015 12.6798 6.32015 12.6798 6.71015 12.2898L17.2901 1.70983C17.4771 1.52286 17.5822 1.26926 17.5822 1.00483C17.5822 0.740407 17.4771 0.486811 17.2901 0.299833C17.1032 0.112856 16.8496 0.0078125 16.5851 0.0078125C16.3207 0.0078125 16.0671 0.112856 15.8801 0.299833L6.00015 10.1698Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.7a3b82404e5f8d432b95cd1a3d195d7a.svg";
export { ForwardRef as ReactComponent };